import { render } from "./MshelMentorship.vue?vue&type=template&id=4f5d36fa&scoped=true"
import script from "./MshelMentorship.vue?vue&type=script&lang=js"
export * from "./MshelMentorship.vue?vue&type=script&lang=js"

import "./MshelMentorship.vue?vue&type=style&index=0&id=4f5d36fa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5d36fa"]])

export default __exports__